import { NextPageContext } from 'next';

import CmsPage from 'models/CmsPage';

import { single as singleCmsPage } from 'requests/cmsPages';

import Component from './component';
import { Props } from './types';


Component.getInitialProps = async (appContext: NextPageContext): Promise<Props> => {
    let cmsPage: CmsPage = null;

    try {
        await Promise.all([
            singleCmsPage({ slug: 'about' }),
        ]).then(responses => {
            cmsPage = responses[0];
        });
    } catch (error) {
        console.error(error);
    }

    return {
        cmsPage: cmsPage || null,
    };
};

export default Component;
